import { useState } from "react";
import { Button } from "@/components/ui/button";
import TrialSignupDialog from "@/components/TrialSignupDialog";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  const [trialOpen, setTrialOpen] = useState(false);
  return (
    <section className="py-24 sm:py-32 bg-[#F4B183]">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 text-center">
        <div className="overline text-[#183D36] mb-5">Your next visit is a message away</div>
        <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#183D36] leading-[1.05] max-w-4xl mx-auto">
          Turn every visit into the next one — starting today.
        </h2>
        <p className="mt-6 text-lg text-[#252525]/85 max-w-xl mx-auto">
          14 days free. No credit card. Cancel any time.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            data-testid="final-cta-start-btn"
            onClick={() => setTrialOpen(true)}
            className="rounded-full bg-[#183D36] hover:bg-[#122e29] text-[#FAF7F0] px-8 py-6 text-base font-medium shadow-lg hover:-translate-y-0.5 transition-all"
          >
            Start free trial
            <ArrowRight className="ml-2" size={18} />
          </Button>
          <Button
            data-testid="final-cta-pricing-btn"
            variant="ghost"
            asChild
            className="rounded-full border border-[#183D36]/20 hover:bg-[#183D36]/10 text-[#183D36] px-8 py-6 text-base"
          >
            <a href="#pricing">See pricing</a>
          </Button>
        </div>
      </div>
      <TrialSignupDialog open={trialOpen} onOpenChange={setTrialOpen} />
    </section>
  );
}
